// extracted by mini-css-extract-plugin
export default {"emptyNotice":"GroupedArticles_emptyNotice__GbHmF","footer":"GroupedArticles_footer__YCgCI"};